define('v3/Common/Bindings/HeightAnimation.Binding',['jquery', 'knockout'], function ($, ko) {
	ko.bindingHandlers.heightanimation = {

		update: function (element, valueAccessor) {
			var $window = $(window);
			var $element = $(element);
			var values = ko.unwrap(valueAccessor());
			var visible = values === Object(values) ? values.visible : values;

			function setIsAnimating (isAnimating) {
				if (ko.isWritableObservable(values.isAnimating)) { values.isAnimating(isAnimating); }
			}

			function callOnAnimationEndCallback () {
				if (values.onAnimationEndCallback) { values.onAnimationEndCallback(element); }
			}

			function onTransitionEnd (isVisible) {
				if (isVisible) {
					$element.addClass('animationDone');
				} else {
					$element.css('height', 0);
				}

				setIsAnimating(false);
				callOnAnimationEndCallback();
			}

			if (ko.computedContext.isInitial()) {
				if (visible) {
					$element.addClass('animationDone');
				} else {
					$element.css('height', 0);
				}

				$(element).addClass('animateHeight');
			} else {
				$element.stop(true);

				var hasAnimationDone = $element.hasClass('animationDone');
				if (hasAnimationDone) {
					$element.removeClass('animationDone');
				}

				setIsAnimating(true);

				var preserveScrollPositionOnClose = false;
				if (!visible) {
					preserveScrollPositionOnClose = $window.data('preserve-scroll-position');
					$window.data('preserve-scroll-position', null);
				}

				var rect = element.getBoundingClientRect();

				var targetHeight = $element.prop('scrollHeight');
				var currentHeight = rect.height;

				// workaround for IE - it fails to get proper height from time to time
				if (hasAnimationDone && Math.abs(targetHeight - currentHeight) > 50) {
					currentHeight = targetHeight;
				}

				var scrollTop = $window.scrollTop();
				var targetScrollTop = scrollTop - currentHeight;

				if (!visible && !currentHeight) {
					return;
				}

				if (preserveScrollPositionOnClose) {
					if (rect.bottom < 0 || rect.top > $window.height()) {
						window.requestAnimationFrame(function () {
							onTransitionEnd(visible);
							$window.scrollTop(targetScrollTop);
						});

						return;
					}
				}

				$element.animate({ height: visible ? targetHeight : 0 }, {
					duration: 300,
					step: function (now) {
						if (preserveScrollPositionOnClose) {
							now = Math.round(now);
							scrollTop = scrollTop - currentHeight + now;
							currentHeight = now;

							window.requestAnimationFrame(function () {
								$window.scrollTop(scrollTop);
							});
						}
					},
					complete: function () {
						onTransitionEnd(visible);

						if (preserveScrollPositionOnClose) {
							window.requestAnimationFrame(function () {
								$window.scrollTop(targetScrollTop);
							});
						}
					}
				});
			}
		}
	};
});
